import { AppButton } from '@/features/product-card/app-button';
import { AppButtonPricing } from '@/features/product-card/app-button';
import NotSalable from './not-salable';
import PDPButton from './pdp-button';
import SnappPayMessage from './snapp-pay-message';
import { generateVariantErrorMessage } from '../_utils/generate-variant-error-message';
import { showVariantErrorToast } from '../_utils/show-variant-error-toast';
import usePDPData from '../_utils/use-pdp-data';
import { useVariantContextValues } from '../context/use-variant-context-values';
function PDPCta() {
  const {
    data
  } = usePDPData();
  const {
    activePricing,
    hasWeightOptions,
    hasColorOptions,
    hasAtleastOneWeightUnit
  } = useVariantContextValues('pdp');
  const {
    basePrice,
    discountPercent,
    effectivePrice,
    isSalable
  } = activePricing;
  const hasVariants = data?.variants?.length && data.variants.length > 1;
  const showVariantErrorHandler = () => {
    const errorMessage = generateVariantErrorMessage({
      hasWeightOptions,
      hasColorOptions,
      hasAtleastOneWeightUnit
    });
    showVariantErrorToast(errorMessage);
  };
  return <div className='sticky bottom-0 right-0 z-20 w-full lg:hidden' data-sentry-component="PDPCta" data-sentry-source-file="pdp-cta.tsx">
            <SnappPayMessage mode='mobile' data-sentry-element="SnappPayMessage" data-sentry-source-file="pdp-cta.tsx" />

            <AppButton isSingleButton={!isSalable} className={!isSalable && !hasVariants ? 'h-[90px]' : ''} data-sentry-element="AppButton" data-sentry-source-file="pdp-cta.tsx">
                {isSalable ? <>
                        <PDPButton showVariantErrorHandler={showVariantErrorHandler} />

                        <AppButtonPricing basePrice={basePrice} discountPercent={discountPercent} effectivePrice={effectivePrice} withGoldPricing contextType='pdp' />
                    </> : <NotSalable type='cta' />}
            </AppButton>
        </div>;
}
export default PDPCta;